<template>
  <div class="home">
    <HeaderGlobal :secondaryHeader="false" :qtSomos="qtSomos" />
    <div class="container-fluid">
      <div class="container border-left-light pt-2 pb-5">
        <div class="row">
          <div
            class="col-md-6 mx-auto pl-md-1 pr-md-0 pl-md-5 pl-lg-5 pr-lg-0 text-center"
          >
            <div v-if="loading" class="pt-5 text-second-color">
              <p>Carregando...</p>
            </div>

            <div v-else-if="error" class="pt-5 text-second-color">
              <p>{{ error }}</p>
            </div>

            <div v-else class="text-center">
              <div v-if="content.end && content.end.length" class="pt-3 text-second-color extra-bold">
                <h4 v-if="content.end[0]" class="text-first-color mb-3">
                  <strong>{{ content.end[0] }}</strong>
                </h4>
                <h4 v-if="content.end[1]" class="mb-2">
                  {{ content.end[1] }}<br />
                  <span v-if="content.end[2]">{{ content.end[2] }}</span>
                </h4>
              </div>

              <div v-if="content.thank && content.thank.length">
                <h5 class="text-second-color mb-3">
                  <span v-if="nome != 'undefined'">
                    {{ nome }},
                    {{ content.thank[0].toLowerCase() + content.thank.slice(1) }}
                  </span>
                  <span v-else-if="nome == 'undefined' && nomeTwo.length >= 2">
                    {{ nomeTwo.trim() }},
                    {{ content.thank[0].toLowerCase() + content.thank.slice(1) }}
                  </span>
                  <span v-else>
                    {{ content.thank[0].toUpperCase() + content.thank.slice(1) }}
                  </span>
                </h5>
              </div>

              <h3
                v-if="content.closer"
                class="pt-3 mb-5 text-first-color extra-bold"
              >
                {{ content.closer }}
              </h3>

              <h4 v-if="content.text" class="text-second-color">
                {{ content.text }}
              </h4>

              <h5
                v-if="content.sharing && content.sharing.length >= 3"
                class="mt-3 mb-4 pt-3 text-second-color c-sharing"
              >
                {{ content.sharing[0] }}
                <strong class="text-first-color">{{ content.sharing[1] }}</strong>
                {{ content.sharing[2] }}
              </h5>

              <div v-if="sharingOptions && sharingOptions.length > 0">
                <article v-if="content.sharing && content.sharing.length" class="mb-3 pt-2">
                  <ShareNetwork
                    v-for="(option, i) in sharingOptions"
                    :key="i"
                    :network="option"
                    :url="projectURL"
                    :title="projectTag"
                    :description="fillString(sharingMessage)"
                    :quote="fillString(sharingMessage)"
                  >
                    <img :src="getLogoUrl(option)" class="mx-3" :alt="option" />
                  </ShareNetwork>
                </article>
              </div>

              <h5 v-if="content.final" class="text-second-color">
                {{ content.final }}
              </h5>
              <br />
              <br />
              <h4 v-if="content.hashtag" class="mb-4 text-second-color">
                <strong>{{ content.hashtag }}</strong>
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>
    <FooterGlobal :secondaryFooter="false" :qtSomos="qtSomos" />
  </div>
</template>

<script>
import FooterGlobal from "./FooterGlobal";
import HeaderGlobal from "./HeaderGlobal";
import { Survey } from "../services/Survey.js";

const surveyService = new Survey();

export default {
  name: "SurveyFinalFromAPI",
  components: {
    FooterGlobal,
    HeaderGlobal,
  },
  data: () => ({
    loading: false,
    error: null,
    apiContent: null,
    sharingIcons: [
      { name: "facebook", url: "static/assets/img/ic-fb-white.png", urlBlack: "static/assets/img/ic-fb-black.png" },
      { name: "whatsapp", url: "static/assets/img/ic-wp-white.png", urlBlack: "static/assets/img/ic-wp-black.png" },
      { name: "linkedin", url: "static/assets/img/ic-in-white.png", urlBlack: "static/assets/img/ic-in-black.png" },
      { name: "twitter", url: "static/assets/img/ic-twitter-white.png", urlBlack: "static/assets/img/ic-twitter-black.png" },
      { name: "instagram", url: "static/assets/img/ic-insta-white.png", urlBlack: "static/assets/img/ic-insta-black.png" },
      { name: "telegram", url: "static/assets/img/ic-telegram-white.png", urlBlack: "static/assets/img/ic-telegram-black.png" },
      { name: "messenger", url: "static/assets/img/ic-messenger-white.png", urlBlack: "static/assets/img/ic-messenger-black.png" },
    ],
  }),
  computed: {
    content() {
      if (this.apiContent) return this.apiContent;
      return this.normalizeEndSurvey(this.$store.state.endSurvey);
    },
    nomeTwo() {
      return this.$store.state.nomeTwo;
    },
    sharingOptions() {
      if (this.content.sharingOption && this.content.sharingOption.length) {
        return this.content.sharingOption;
      }
      if (this.content.sharing && this.content.sharing.length) {
        return ["facebook", "whatsapp"];
      }
      return [];
    },
    projectTag() {
      return "#" + this.$store.state.project.projectTag;
    },
    sharingMessage() {
      return this.$store.state.project.sharingMessage;
    },
    projectURL() {
      return "https://" + this.$store.state.project.projectURL + "/";
    },
    nome() {
      var socialName = this.fillString("<@RQ:141@>");
      var n = this.fillString("<@RQ:101@>");
      if (socialName && socialName != "undefined") return socialName;
      return n;
    },
    userSurveyId() {
      return this.$store.state.surveyUserId || null;
    },
    qtSomos() {
      return this.$store.state.qtUsers;
    },
  },
  beforeMount() {
    if (!this.$store.state.template.style) {
      this.$nextTick(() => {
        this.$router.push("home");
      });
    }
  },
  created() {
    this.fetchEndSurvey();
  },
  methods: {
    normalizeEndSurvey(data) {
      if (!data || typeof data !== "object") return {};
      return data;
    },
    hasContent(data) {
      const normalized = this.normalizeEndSurvey(data);
      return Object.keys(normalized).length > 0;
    },
    fetchEndSurvey() {
      if (!this.userSurveyId) {
        this.error = "Não foi possível carregar a tela final.";
        return;
      }

      this.loading = true;
      this.error = null;

      surveyService
        .GetEndSurvey(this.userSurveyId)
        .then((ret) => {
          if (ret.header?.codigo === 1 && ret.header?.msg === "redirect") {
            window.location.href = ret.data;
            return;
          }
          this.apiContent = ret.data;
          this.$store.dispatch("set_endSurvey", ret.data);
        })
        .catch((err) => {
          this.error =
            typeof err === "string"
              ? err
              : "Não foi possível carregar a tela final.";
        })
        .finally(() => {
          this.loading = false;
        });
    },
    fillString(s) {
      if (!s) return s;
      if (s.includes("<@") && s.includes("@>")) {
        var s1 = s.split("<@");
        var s2 = s1[1].split("@>");
        var s3 = s2[0].split(":");
        var rid = s3[1];
        const value = this.$store.state.answers[rid];
        s = s1[0] + value + s2[1];
      }
      return s;
    },
    getLogoUrl(optionName) {
      let obj = this.sharingIcons.find((el) => el.name === optionName);
      if (!this.$store.state.template.style.defaultTextColor) return obj.url;
      return obj.urlBlack;
    },
  },
};
</script>

<style scoped>
.c-sharing {
  font-size: 1.5rem;
  font-weight: 300;
}

a:hover {
  color: var(--first-color);
}
</style>
